import { RootState } from "../rootReducer"

export const selectArticleCommentState = (state: RootState) => state.knowledgeBaseComments.currentComments
export const selectArticleCommentThreadState = (state: RootState) => state.knowledgeBaseComments.currentThread
export const selectArticleCommentInputStates = (state: RootState) => state.knowledgeBaseComments.inputStates
export const selectArticleCommentSendState = (state: RootState) => state.knowledgeBaseComments.addComment
export const selectArticleReplySendState = (state: RootState) => state.knowledgeBaseComments.addReply
